import { render, staticRenderFns } from "./DocumentPortalOthers.vue?vue&type=template&id=8c52a276&scoped=true&"
import script from "./DocumentPortalOthers.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalOthers.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalOthers.vue?vue&type=style&index=0&id=8c52a276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c52a276",
  null
  
)

export default component.exports